import PrintAssetFormModal, { PRINT_ASSET_FORM_MODAL } from './modal';

export { PRINT_ASSET_FORM_MODAL };

export default PrintAssetFormModal;
